import { all, update, remove } from '../services/restApi'
import { message } from 'antd'
import { getTotal } from '../utils'
import moment from 'moment'
message.config({top: 110, duration: 4});
const _ = require('underscore')

const limit = 100;

export default {
	namespace : 'income',
	state : {
		incomes: [],
		skip: 0,
		limit: limit,
		total_items: 0
	},
	effects : {
		*update({payload}, {call, put}) {
			yield put({type: 'app/showButtonLoading'})

			try {

				let data = {...payload}
				data = _.omit(data, ['objectId', 'parentId', 'createdAt', 'updatedAt']);

				yield call(update, 'Income', payload.objectId, data);
				yield put({ type: 'updateSuccess', payload: {...data, objectId: payload.objectId, parentId: payload.parentId} })
				message.success('Se ha actualizado el registro exitosamente');

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')	
			}

			yield put({type: 'app/hideButtonLoading'})

		},
		*removeItem({payload}, {call, put}) {
			yield put({type: 'app/showLoadingTable'})

			try {

				if (payload.type === 'payroll') {

					let income = yield call(all, 'Income', {
						where: {
							payroll: {__type: 'Pointer', className: 'Payroll', objectId: payload.objectId}
						}
					});

					// Elimina los gastos de la tabla Income pertenecientes al registro de la tabla Payroll
					if (income.results.length > 0) {
						yield* income.results.map(item => {
							return call(remove, 'Income', item.objectId)
						});
					}

					yield call(remove, 'Payroll', payload.objectId);
					yield put({type: 'removeSuccess', payload: payload})

				} else if (payload.type === 'commission') {

					let income = yield call(all, 'Income', {
						where: {
							commission: {__type: 'Pointer', className: 'Commission', objectId: payload.objectId}
						}
					});

					// Elimina los gastos de la tabla Income pertenecientes al registro de la tabla Commission
					if (income.results.length > 0) {
						yield* income.results.map(item => {
							return call(remove, 'Income', item.objectId)
						});
					}

					yield call(remove, 'Commission', payload.objectId);
					yield put({type: 'removeSuccess', payload: payload})

				} else {
					yield call(remove, 'Income', payload.objectId);
					yield put({type: 'removeSuccess', payload: payload})
				}

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')	
			}

			yield put({type: 'app/hideLoadingTable'})

		}
	},
	reducers : {
		queryFirst(state, action) {
			return {
				...state,
				...action.payload
			}
		},
		querySuccess(state, action) {
			return {
				...state,
				incomes: state.incomes.concat(action.payload.incomes),
				skip: action.payload.skip,
				total_items: action.payload.total_items
			}
		},
		filterSuccess(state, action) {
			return {
				...state,
				incomes: action.payload.incomes,
				skip: action.payload.skip,
				total_items: action.payload.total_items
			}
		},
		createSuccess(state, action) {
			return {
				...state,
    			incomes: [action.payload, ...state.incomes]
			}
		},
		updateSuccess(state, action) {
			const parent = _.find(state.incomes, {objectId: action.payload.parentId});

			if (parent) {
				const obj = _.find(parent.children, {objectId: action.payload.objectId});
				_.extend(obj, action.payload);

			} else {
				const parent = _.find(state.incomes, {objectId: action.payload.objectId});
				_.extend(parent, action.payload);
			}

			return {
				...state,
    			...action.payload
			}
		},
		removeSuccess(state, action) {

			if (action.payload.type === 'payments' || action.payload.type === 'payroll' || action.payload.type === 'commission') {
				// El movimiento es un "Pago o depósito"
				state.incomes = _.without(state.incomes, _.find(state.incomes, {objectId: action.payload.objectId}));

			} else {
				// El movimiento es diferente a "Pago o depósito"

				let expense = _.find(state.incomes, function (item) { return item.requestedAt.iso === moment(action.payload.requestedAt.iso).format('YYYY-MM-DD')});

				if (expense.children) {
					let children = _.find(expense.children, {objectId: action.payload.objectId});

					// Update
					expense.children = _.without(expense.children, children);
					expense.amount_income_total = getTotal(expense.children, 'amount_income');
					expense.amount_expense_total = getTotal(expense.children, 'amount_expense');

					if (expense.children.length === 0) {
						state.incomes = _.without(state.incomes, _.find(state.incomes, {objectId: expense.objectId}));
					}
				}
			}

			return {
				...state,
    			incomes: state.incomes
			}
		}
	}
}


// WEBPACK FOOTER //
// ./src/models/income.js